import React from "react";

import SquareGrid from "icons/SquareGrid";
import SubmissionsDeniedItem from "./SubmissionsDeniedItem";

import { useViewport } from "js/hooks/useViewport";
import breakpoints from "core/breakpoints";

// TODO: remove mock content when endpoint is ready
import { mockDataList } from "core/JustifiedGrid/__mocks__";

const DeniedGrid = () => {
    const { browserWidth } = useViewport();
    const isMobile = browserWidth <= breakpoints.beforeTablet.px;

    const items = mockDataList.map((data, index) => (
        <SubmissionsDeniedItem key={index} submissionData={data} />
    ));

    return (
        <SquareGrid
            gridItemContent={items}
            numberOfColumns={isMobile ? 1 : 5}
            gridSpacingSize={isMobile ? "1rem" : "1.5rem"}
        />
    );
};

export default DeniedGrid;
